import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, FormGroup, Label, Input, Nav, NavItem, NavLink } from 'reactstrap';
import Select from 'react-select';
import classnames from 'classnames';
import CalendarView from './calenderView';
import { useFetch2 } from "components/utils/authenticatedHook";
import { fill } from 'lodash';
import moment from 'moment';
import { ScheduledAndUnScheduledSubject } from '../../constants/general.constant';
import { useSelector, useDispatch } from "react-redux";
import { ROLES } from '../../constants/role.constant';
import getDeviceType from "../../helpers/getDeviceTypeHelper";
import {deviceType} from "../../constants/general.constant";

const AppointmentCalendar = () => {
  const dispatch = useDispatch();
  const [{ response, error, isLoading }, doFetch, sendError] = useFetch2();
  const [{ response: careproviderStaff, error: getError, isLoading: loadingCareprovider }, doFetch2, sendError2] = useFetch2();
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
  const [selectedTypes, setSelectedTypes] = useState([ScheduledAndUnScheduledSubject.scheduled, ScheduledAndUnScheduledSubject.unScheduled, ScheduledAndUnScheduledSubject.monthlyCheckCall, ScheduledAndUnScheduledSubject.followUpPhoneCall]);
  const [myCalendarChecked, setMyCalendarChecked] = useState(true);
  const [otherCalendarChecked, setOtherCalendarChecked] = useState(false);
  const [selectedCareProviders, setSelectedCareProviders] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [query, setQuery] = useState({subject: [ScheduledAndUnScheduledSubject.scheduled, ScheduledAndUnScheduledSubject.unScheduled, ScheduledAndUnScheduledSubject.monthlyCheckCall, ScheduledAndUnScheduledSubject.followUpPhoneCall], myCalendar: true, otherCalendar: false})
  const { userDetails } = useSelector(state => state.user);
  const device = getDeviceType();

  // Call unread count API on component mount
  useEffect(() => {
    dispatch({
      type: "DO_GET_UNREAD_COUNT"
    });
  }, []);

  const handleMyCalendarChange = (e) => {
    setMyCalendarChecked(e.target.checked);
    setQuery({...query, myCalendar: e.target.checked});
  };

  const handleOtherCalendarChange = (e) => {
    setOtherCalendarChecked(e.target.checked);
    if(!e.target.checked){
    setSelectedStaff([]);
    setSelectedCareProviders([]);
    setQuery({...query, staff: [], careprovider: [], otherCalendar: e.target.checked});
    }else{
      setQuery({...query, otherCalendar: e.target.checked});
    }
  };

  const handleTypeToggle = (type) => {
    const newSelected = selectedTypes.includes(type) ? selectedTypes.filter(t => t !== type) : [...selectedTypes, type];
    setSelectedTypes(newSelected);
    setQuery({...query, subject: newSelected});
  };

  const handleCareProviderChange = (selectedOptions) => {
    setSelectedCareProviders(selectedOptions || []);
    const careprovider = [];
    selectedOptions.map((item) => {
      careprovider.push(item.value);
    });
    setQuery({...query, careprovider});
  };

  const handleStaffChange = (selectedOptions) => {
    setSelectedStaff(selectedOptions || []);
    const staff = [];
    selectedOptions.map((item) => {
      staff.push(item.value);
    })
    setQuery({...query, staff});
  };

  const onRangeChange = useCallback((start, end) => {
    setStartDate(start);
    setEndDate(end);
    fetchData({...query, startDate: start, endDate: end});
  }, [query]);

  const fetchData = (query) => {
    doFetch({
      url: "/scheduled-appointment",
      method: "GET",
      disableWait: true,
      query: query,
    });
  }

  useEffect(() => {
    if (userDetails.role === ROLES.admin || userDetails.role === ROLES.careprovider) {
      doFetch2({
        url: "/scheduled-appointment-staff-careprovider",
        method: "GET",
        disableWait: true
      });
    }
  }, []);

  return (
    <div>
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body project-tab pt-2">
              <Nav tabs className="justify-content-center">
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: true
                    })}
                  >
                    Appointment Calendar
                  </NavLink>
                </NavItem>
              </Nav>
              <div className={`col-md-12 mt-4`} style={{marginLeft : "-17px"}}>
                <Row form>
                  <Col md={device === deviceType.tablet ? 4 : 2}>
                    <FormGroup style={{ display: 'flex', alignItems: 'center', padding: '0.5rem', paddingLeft: '2rem', border: '1px solid #ced4da', borderRadius: '0.375rem', backgroundColor: '#f8f9fa', minHeight: '38px'}}>
                      <Label style={{ display: 'flex', alignItems: 'center', marginBottom: '0', cursor: 'pointer', width: '100%' }}>
                        <Input
                          type="checkbox"
                          checked={myCalendarChecked}
                          onChange={handleMyCalendarChange}
                          style={{ marginRight: '0.5rem', marginTop: '0', width: '18px', height: '18px', opacity: 1, position: 'static' }}
                        />
                        <span style={{ fontWeight: '500', color: '#495057' }}>My Calendar</span>
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={device === deviceType.tablet ? 4 : 2}>
                    <FormGroup style={{ display: 'flex', alignItems: 'center', padding: '0.5rem', paddingLeft: '2rem', border: '1px solid #ced4da', borderRadius: '0.375rem', backgroundColor: '#f8f9fa', minHeight: '38px'}}>
                      <Label style={{ display: 'flex', alignItems: 'center', marginBottom: '0', cursor: 'pointer', width: '100%' }}>
                        <Input
                          type="checkbox"
                          checked={otherCalendarChecked}
                          onChange={handleOtherCalendarChange}
                          style={{ marginRight: '0.5rem', marginTop: '0', width: '18px', height: '18px', opacity: 1, position: 'static' }}
                        />
                        <span style={{ fontWeight: '500', color: '#495057' }}>Other Calendar</span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row form>
                  {otherCalendarChecked && (
                    <>
                      {userDetails && (userDetails.role === ROLES.admin) && <Col md={5}>
                        <FormGroup>
                          <Select
                            isMulti
                            name="careProvider"
                            options={careproviderStaff && careproviderStaff.data && careproviderStaff.data.careprovider.sort((a, b) => a.lname.localeCompare(b.lname)).map(option => ({ label: option.lname.charAt(0).toUpperCase() + option.lname.slice(1).toLowerCase() + ", " + option.fname.charAt(0).toUpperCase() + option.fname.slice(1).toLowerCase(), value: option._id }))}
                            value={selectedCareProviders}
                            onChange={handleCareProviderChange}
                            placeholder="Select Care Providers"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                border: '1px solid #ced4da',
                                borderRadius: '0.375rem',
                                minHeight: '40px',
                                fontSize: '0.875rem'
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: '#e9ecef'
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                color: '#495057'
                              }),
                              multiValueRemove: (provided) => ({
                                ...provided,
                                color: '#6c757d',
                                ':hover': {
                                  backgroundColor: '#dc3545',
                                  color: 'white'
                                }
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </FormGroup>
                      </Col>}
                      {userDetails && (userDetails.role === ROLES.admin || userDetails.role === ROLES.careprovider) && <Col md={5}>
                        <FormGroup>
                          <Select
                            isMulti
                            name="staff"
                            options={careproviderStaff.data && careproviderStaff.data.staffs.sort((a, b) => a.lname.localeCompare(b.lname)).map(option => ({ label: option.lname.charAt(0).toUpperCase() + option.lname.slice(1).toLowerCase() + ", " + option.fname.charAt(0).toUpperCase() + option.fname.slice(1).toLowerCase(), value: option._id }))}
                            value={selectedStaff}
                            onChange={handleStaffChange}
                            placeholder="Select Staffs"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                border: '1px solid #ced4da',
                                borderRadius: '0.375rem',
                                minHeight: '40px',
                                fontSize: '0.875rem'
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: '#e9ecef'
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                color: '#495057'
                              }),
                              multiValueRemove: (provided) => ({
                                ...provided,
                                color: '#6c757d',
                                ':hover': {
                                  backgroundColor: '#dc3545',
                                  color: 'white'
                                }
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </FormGroup>
                      </Col>}
                    </>
                  )}
                </Row>
              </div>
              <div className="legend" style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h5 style={{ marginBottom: '10px', fontWeight: 'bold' }}>Appointment Types:</h5>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '1.2rem' }}>
                    <Input type="checkbox" checked={selectedTypes.includes(ScheduledAndUnScheduledSubject.scheduled)} onChange={() => handleTypeToggle(ScheduledAndUnScheduledSubject.scheduled)} style={{accentColor: '#1E90FF	', color: 'white', marginRight: '0.5rem', marginTop: '0', width: '18px', height: '18px', opacity: 1, position: 'static' }} />
                    <span style={{ fontSize: '14px' }}>EHR RPM ONB – Scheduled Appointments</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '1.2rem' }}>
                    <Input type="checkbox" checked={selectedTypes.includes(ScheduledAndUnScheduledSubject.unScheduled)} onChange={() => handleTypeToggle(ScheduledAndUnScheduledSubject.unScheduled)} style={{accentColor: '#FFC107', color: 'white', marginRight: '0.5rem', marginTop: '0', width: '18px', height: '18px', opacity: 1, position: 'static' }} />
                    <span style={{ fontSize: '14px' }}>EHR RPM ONB – No Scheduled Appointment (Device Pickup & Training)</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '1.2rem' }}>
                    <Input type="checkbox" checked={selectedTypes.includes(ScheduledAndUnScheduledSubject.monthlyCheckCall)} onChange={() => handleTypeToggle(ScheduledAndUnScheduledSubject.monthlyCheckCall)} style={{accentColor: '#2ECC71', font: 'white', marginRight: '0.5rem', marginTop: '0', width: '18px', height: '18px', opacity: 1, position: 'static' }} />
                    <span style={{ fontSize: '14px' }}>Monthly Check in Phone Call</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '1.2rem' }}>
                    <Input type="checkbox" checked={selectedTypes.includes(ScheduledAndUnScheduledSubject.followUpPhoneCall)} onChange={() => handleTypeToggle(ScheduledAndUnScheduledSubject.followUpPhoneCall)} style={{accentColor: '#7a2ecc', font: 'white', marginRight: '0.5rem', marginTop: '0', width: '18px', height: '18px', opacity: 1, position: 'static' }} />
                    <span style={{ fontSize: '14px' }}>Follow Up Phone Call</span>
                  </div>
                </div>
              </div>
              <CalendarView startDate={startDate} endDate={endDate} selectedTypes={selectedTypes} appointments={response?.data || []} onRangeChange={onRangeChange} isLoading={isLoading}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentCalendar;
